import type { ComponentProps } from 'react';
// components
import HubertCombobox from 'components/HubertUI/HubertCombobox';
// constants
import { interviewActionsList } from 'components/comboboxes/InterviewActionsCombobox/interviewActionsList';

interface Props extends ComponentProps<'div'> {
  isMulti?: boolean;
  value?: string | string[];
  onValueChange?: (value: string | string[]) => void;
  disabled?: boolean;
}

const InterviewActionsCombobox = ({ isMulti = false, onValueChange, value, disabled = false, ...props }: Props) => {
  return (
    <div {...props}>
      <HubertCombobox
        itemName="action"
        isMulti={isMulti}
        items={interviewActionsList}
        onValueChange={onValueChange}
        value={value}
        disabled={disabled}
      />
    </div>
  );
};

export default InterviewActionsCombobox;
